import { FleekError } from './FleekError';

type GitAccessTokenNotFoundErrorOptions = Record<never, never>;

export class GitAccessTokenNotFoundError extends FleekError<GitAccessTokenNotFoundErrorOptions> {
  public name = 'GitAccessTokenNotFoundError';

  toString = () => {
    return 'The git access token for the user is not found';
  };
}
